import * as React from "react"
const Discord = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#5865F2"
        d="M25.266 0H7.734A7.734 7.734 0 0 0 0 7.734v17.532A7.734 7.734 0 0 0 7.734 33h17.532A7.734 7.734 0 0 0 33 25.266V7.734A7.734 7.734 0 0 0 25.266 0Z"
      />
      <mask
        id="b"
        width={27}
        height={21}
        x={3}
        y={6}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M3.61 6.574h25.78v19.972H3.61V6.574Z" />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#fff"
          d="M25.434 8.353a21.26 21.26 0 0 0-5.247-1.628.08.08 0 0 0-.085.04c-.226.403-.477.929-.653 1.342a19.622 19.622 0 0 0-5.894 0c-.176-.422-.436-.939-.664-1.342a.083.083 0 0 0-.084-.04c-1.813.313-3.577.86-5.248 1.628a.075.075 0 0 0-.034.03c-3.343 4.993-4.258 9.863-3.809 14.674a.089.089 0 0 0 .034.06 21.376 21.376 0 0 0 6.437 3.254.084.084 0 0 0 .09-.03 15.3 15.3 0 0 0 1.318-2.142.082.082 0 0 0-.045-.113 14.088 14.088 0 0 1-2.011-.959.082.082 0 0 1-.04-.066.083.083 0 0 1 .032-.07c.135-.102.268-.206.4-.314a.08.08 0 0 1 .082-.011c4.22 1.926 8.787 1.926 12.957 0a.08.08 0 0 1 .084.01c.131.108.265.213.4.314a.083.083 0 0 1 .022.109.083.083 0 0 1-.028.028 13.24 13.24 0 0 1-2.012.958.082.082 0 0 0-.044.114c.386.745.825 1.46 1.316 2.141a.082.082 0 0 0 .09.031 21.306 21.306 0 0 0 6.448-3.254.083.083 0 0 0 .034-.06c.537-5.56-.9-10.391-3.812-14.674a.065.065 0 0 0-.034-.03Zm-13.21 11.775c-1.27 0-2.316-1.166-2.316-2.599 0-1.432 1.026-2.598 2.317-2.598 1.3 0 2.337 1.176 2.317 2.598 0 1.433-1.027 2.599-2.317 2.599Zm8.567 0c-1.27 0-2.317-1.166-2.317-2.599 0-1.432 1.027-2.598 2.317-2.598 1.301 0 2.337 1.176 2.317 2.598 0 1.433-1.016 2.599-2.317 2.599Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h33v33H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default Discord